import {
  MDSBubbleProps,
  MDSBubbleSlotName,
  MDSBubbleAlignment,
  MDSBubbleVariant,
} from "./bubble.types";
import {
  StyledBubbleWrapper,
  StyledBubbleInner,
  StyledContent,
  StyledLoader,
} from "./bubble.style";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";

export const MDSBubble = ({
  children,
  align = MDSBubbleAlignment.Right,
  isLastInGroup = false,
  isLoading = false,
  hasError = false,
  onClick,
  className,
  variant = MDSBubbleVariant.Grey,
}: MDSBubbleProps) => {
  const iconSlot = getSlot(children, MDSBubbleSlotName.Icon);
  const loaderSlot = getSlot(children, MDSBubbleSlotName.Loader);
  const errorSlot = getSlot(children, MDSBubbleSlotName.Error);
  const unslottedChildren = getUnslottedChildren(children);

  return (
    <StyledBubbleWrapper align={align} onClick={onClick} className={className}>
      <StyledBubbleInner align={align} isLastInGroup={isLastInGroup} variant={variant}>
        {align === MDSBubbleAlignment.Left && iconSlot}
        <StyledContent>
          {unslottedChildren}
          {isLoading && loaderSlot && (
            <StyledLoader addSpace={unslottedChildren.length > 0}>{loaderSlot}</StyledLoader>
          )}
          {hasError && errorSlot}
        </StyledContent>
      </StyledBubbleInner>
    </StyledBubbleWrapper>
  );
};
